import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ContainerButton from "./ContainerButton";
import emptyImage from "./assets/empty-state.svg";
import TextCreationArea from "./TextCreationArea";
import useStartupStore from "../stores/startupStore";
import EditorContentDisplay from "./EditorContentDisplay";
import ProgramChangesApproval from "../components/Startups/ProgramUpdateApproval";
import { LoadingOverlay } from "@mantine/core";
import DiffDisplay from "../components/Startups/DiffDisplay";
import SVGSliderLoader from "./SVGSliderLoader";

const RoadmapDetailsContainer = styled.div`
  width: 100%;
  // background-color: var(--color-container-card-default);
  // border: 1px solid #dee8e7;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: fit-content;
  overflow-x: auto;
`;

const RoadmapTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;
  align-items: center;
  justify-content: center; /* center horizontally */
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  border-bottom: 1px solid rgba(0,0,0,0.06);

  overflow: visible;
  padding: 6px 8px;
`;

const TabButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 8px 14px;
  cursor: pointer;
  color: var(--color-background-card);
  font-weight: var(--font-weight-h4);
  font-size: 0.95rem;
  line-height: 1.15;
  border-bottom: none;
  text-align: center;
  transition: all 0.3s ease;
  white-space: nowrap;
  border-radius: 9999px;
  margin: 2px 0;
  position: relative;

  &:hover {
    background-color: rgba(108, 69, 231, 0.08);
  }

  &.active {
    color: var(--color-navigation-icon-light);
  }

  &::after {
    content: "";
    position: absolute;
    left: 10px;
    right: 10px;
    bottom: 0px;
    height: 2px;
    background: var(--color-navigation-icon-light);
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 200ms ease;
    border-radius: 1px;
  }

  &.active::after {
    transform: scaleX(1);
  }
`;

const RoadmapContent = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 120px; /* safe area for floating assistant */
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 24px 8px;

  img {
    margin-bottom: 16px;
    max-width: 280px;
    width: 100%;
  }
  p { margin-top: 4px; color: #6b7280; font-size: 0.9rem; }
`;

const EditorCard = styled.div`
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
  padding: 20px;
`;

const RoadmapDetails = ({isSyncing, setShowTask}) => {
  const [showChanges, setShowChanges] = useState(false);
  const [showAlert, setShowAlert] = useState(true);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const {
    isOwner,
    isMember,
    role,
    selectedProgram,
    setSelectedProgram,
    editMode,
    setEditMode,
    members,
    program,
    setSubcategory,
  } = useStartupStore((state) => ({
    program: state.program,
    setProgram: state.setProgram,
    isOwner: state.isOwner,
    isMember: state.isMember,
    setSubcategory: state.setSubcategory,
    selectedProgram: state.selectedProgram,
    setSelectedProgram: state.setSelectedProgram,
    editMode: state.editMode,
    setEditMode: state.setEditMode,
    members: state.members,
  }));
  const handleTabClick = (index) => {
    setSelectedProgram({ sid: index });
  };
  
  return (
      <RoadmapDetailsContainer>
        {program?.categories?.length ? (
          <>
            <RoadmapTabs role="tablist" aria-label="Roadmap steps">
              {program.categories[selectedProgram.cid].sub_categories.map(
                (tab, index) => (
                  <TabButton
                    key={tab.id}
                    className={index === selectedProgram.sid ? "active" : ""}
                    role="tab"
                    aria-selected={index === selectedProgram.sid}
                    onClick={() => handleTabClick(index)}
                  >
                    {tab.name}
                  </TabButton>
                )
              )}
            </RoadmapTabs>

            <RoadmapContent>
              <LoadingOverlay
                style={{ alignItems: "flex-start" }}
                loader={<SVGSliderLoader />}
                visible={program.loading}
              />
              {editMode ? (
                <>
                  {program.categories[selectedProgram.cid].sub_categories[
                    selectedProgram.sid
                  ].response ||
                  program.categories[selectedProgram.cid].sub_categories[
                    selectedProgram.sid
                  ].diff_proposed_response ? (
                    <>
                      {showChanges && isMember ? (
                        <DiffDisplay
                          diffResult={
                            program.categories[selectedProgram.cid]
                              .sub_categories[selectedProgram.sid]
                              .diff_proposed_response
                          }
                        />
                      ) : (
                        <EditorContentDisplay
                          content={
                            program.categories[selectedProgram.cid]
                              .sub_categories[selectedProgram.sid].response
                          }
                        />
                      )}
                      {isMember && (
                        <EmptyState
                          key={
                            program.categories[selectedProgram.cid]
                              .sub_categories[selectedProgram.sid]
                              .waiting_for_approval
                          }
                          style={{ marginTop: "44px" }}
                        >
                          <div style={{ display: "flex", gap: "4px" }}>
                            {!program.categories[selectedProgram.cid]
                              .sub_categories[selectedProgram.sid]
                              .waiting_for_approval ? (
                              <ContainerButton
                                action={() => setEditMode(true)}
                                buttonText={`Edit ${
                                  program.categories[selectedProgram.cid]
                                    .sub_categories[selectedProgram.sid].name
                                }`}
                              />
                            ) : (
                              <>
                                <ContainerButton
                                  action={() => setShowChanges(!showChanges)}
                                  buttonText={
                                    showChanges
                                      ? "Back"
                                      : "New Changes Submitted"
                                  }
                                />

                                {showChanges && isOwner && (
                                  <ProgramChangesApproval
                                    id={
                                      program.categories[selectedProgram.cid]
                                        .sub_categories[selectedProgram.sid].id
                                    }
                                    toggle={() => setShowChanges(false)}
                                    setSubcategory={setSubcategory}
                                  />
                                )}
                              </>
                            )}
                          </div>
                        </EmptyState>
                      )}
                    </>
                  ) : (
                    <EmptyState>
                      <img src={emptyImage} alt="Empty Content" />
                      {isMember && (
                        <ContainerButton
                          action={() => setEditMode(true)}
                          buttonText={`Create ${
                            program.categories[selectedProgram.cid]
                              .sub_categories[selectedProgram.sid].name
                          }`}
                        />
                      )}
                    </EmptyState>
                  )}
                </>
              ) : (
                <EditorCard>
                  <TextCreationArea
                    key={"" + selectedProgram.cid + program.loading}
                    index={selectedProgram.sid}
                    setMessage={setMessage}
                    setLoading={setLoading}
                    loading={program.loading}
                    setShowAlert={setShowAlert}
                    showAlert={showAlert}
                    isSyncing={isSyncing}
                    setShowTask={setShowTask}
                  />
                </EditorCard>
              )}
            </RoadmapContent>
          </>
        ) : (
          <>
            {program.loading ? (
              <SVGSliderLoader />
            ) : (
              <EmptyState>
                <img src={emptyImage} alt="Empty Content" />
              </EmptyState>
            )}
          </>
        )}
      </RoadmapDetailsContainer>
  );
};

export default RoadmapDetails;
